export default class InputValidationUtils {
  public static emailRegex(): RegExp {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  }

  public static alternativeEmailRegex(): RegExp {
    return /^(([^<>()\[\]\\.,+;:\s@"]+(\.[^<>()\[\]\\.,+;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  }

  public static phoneRegex(): RegExp {
    return /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g;
  }

  public static numberRegex(): RegExp {
    return /^[0-9]/g;
  }

  public static zipCodeRegex(): RegExp {
    return /^\d{5}(?:[- ]?\d{4})?$/;
  }
}
